import {
  Action,
  ActionType,
  IMiniStressTypeInfoResponse,
} from "models/stressCheck/miniStressInformation";
import createReducer from "redux/createReducer";

export interface MiniStressCheckTypeInfoReducerType {
  loading: boolean;
  error?: string;
  miniStressCheckTypeInfoResponse?: IMiniStressTypeInfoResponse;
}

const defaultState: MiniStressCheckTypeInfoReducerType = {
  loading: false,
  error: undefined,
  miniStressCheckTypeInfoResponse: undefined,
};

export const miniStressCheckTypeInfoReducer =
  createReducer<MiniStressCheckTypeInfoReducerType>(defaultState, {
    [ActionType.MINI_STRESS_INFO](state: MiniStressCheckTypeInfoReducerType) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.MINI_STRESS_INFO_ERROR](
      state: MiniStressCheckTypeInfoReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
        miniStressCheckTypeInfoResponse: undefined,
      };
    },

    [ActionType.MINI_STRESS_INFO_SUCCESS](
      state: MiniStressCheckTypeInfoReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        miniStressCheckTypeInfoResponse: action.payload,
      };
    },

    [ActionType.MINI_STRESS_INFO_RESET_DATA](
      state: MiniStressCheckTypeInfoReducerType
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        miniStressCheckTypeInfoResponse: undefined,
      };
    },
  });
